/*
 * @Description: computer mutations type
 */
export enum MoocMutationTypes {
    //导航
    SET_MOOC_NAV = 'SET_MOOC_NAV',

  }